import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Faltan las variables de entorno de Supabase');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface Estudiante {
  id?: string;
  nombre_completo: string;
  email: string;
  telefono: string;
  pais: string;
  plan_pago: 'pago_unico' | '4_pagos';
  monto_total: number;
  estado_pago?: string;
  fecha_inscripcion?: string;
  notas?: string;
}
